module.exports = __webpack_public_path__ + "static/media/logo.59d06429.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logo.png
// module id = 350
// module chunks = 11